interface LogoProps {
  variant?: 'dark' | 'light';
  className?: string;
}

export default function Logo({ variant = 'dark', className = '' }: LogoProps) {
  const textColor = variant === 'dark' ? 'text-primary' : 'text-cream';

  // This component is prepared to accept an image logo later
  // For now, it displays the text logo
  return (
    <div className={`font-display font-semibold tracking-wide ${textColor} ${className}`}>
      <span className="text-lg md:text-xl">КАСТАЛИЯ НЕЙЛС</span>
    </div>
  );
}
